/** A locale the app UI can be switched to. */
export interface LanguageOption {
  code: SupportedLocale
  /** Endonym: languages read best in their own language. */
  label: string
  /** ISO 3166-1 alpha-2, lowercased, naming a file in `src/assets/flags/`. */
  flag: string
}

export const SUPPORTED_LOCALES = ['en', 'de', 'it'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: SupportedLocale = 'en'

/** English is flagged `gb` rather than `us`: the flag stands for the locale shipped, not every English-speaking country. */
export const LANGUAGES: readonly LanguageOption[] = [
  { code: 'en', label: 'English', flag: 'gb' },
  { code: 'de', label: 'Deutsch', flag: 'de' },
  { code: 'it', label: 'Italiano', flag: 'it' },
]

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

export function languageFor(code: SupportedLocale): LanguageOption {
  return LANGUAGES.find((language) => language.code === code) ?? LANGUAGES[0]!
}
